var _path, _path2, _path3, _path4, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOhm({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1498_3201)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 20.2435 1.68571 24.3131 4.68629 27.3137C7.68687 30.3143 11.7565 32 16 32C20.2435 32 24.3131 30.3143 27.3137 27.3137C30.3143 24.3131 32 20.2435 32 16C32 11.7565 30.3143 7.68687 27.3137 4.68629C24.3131 1.68571 20.2435 0 16 0C11.7565 0 7.68687 1.68571 4.68629 4.68629C1.68571 7.68687 0 11.7565 0 16Z",
    fill: "#FCD000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1498_3201",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -14,
    y: 8,
    width: 60,
    height: 18
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5018 25.1403C26.6207 25.1403 23.7389 25.12 20.8583 25.1475C19.082 25.1644 17.758 24.0279 17.3682 22.7992C17.1864 22.227 17.1278 21.6097 17.0585 21.0083C16.7398 18.2464 14.8204 15.787 11.7247 15.386C11.3817 15.3416 11.032 15.3365 10.6851 15.3353C4.85676 15.3196 -0.971534 15.3078 -6.79983 15.2954C-7.08221 15.2946 -7.2237 15.1568 -7.22449 14.882C-7.22449 12.7329 -7.22449 10.5839 -7.22449 8.43422C-7.22449 8.16277 -7.09061 8.02667 -6.82295 8.02592C-0.919717 8.01803 4.98348 8.01409 10.8867 8.00001C12.3115 7.99663 13.3326 8.65724 14.0467 9.84611C14.4454 10.5095 14.5744 11.2546 14.6865 12.0104C14.9748 13.9448 15.7565 15.6136 17.3992 16.7782C18.4101 17.4946 19.5545 17.801 20.7861 17.8026C26.7175 17.81 32.6489 17.8172 38.5802 17.8246C38.8693 17.8246 39.0141 17.9688 39.0144 18.2571C39.0144 20.4062 39.0144 22.5553 39.0144 24.7049C39.0144 25.0929 39.0133 25.0946 38.623 25.0946C35.5824 25.0946 32.5413 25.0946 29.5007 25.0946V25.1403H29.5018Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-1.03729 25.0955C-5.15634 25.0955 -9.276 25.0955 -13.395 25.0955C-13.8123 25.0955 -13.8135 25.0932 -13.8135 24.6753C-13.8135 22.5172 -13.8135 20.3591 -13.8135 18.2005C-13.8135 17.8282 -13.8095 17.8249 -13.4362 17.8243C-5.29153 17.8164 2.85368 17.8074 10.9983 17.8018C12.9863 17.8006 14.597 19.4519 14.6341 21.4433C14.664 23.0145 13.5529 24.7209 11.6539 25.0881C11.3892 25.1393 11.1126 25.1461 10.8417 25.1461C6.88207 25.1495 2.92239 25.1483 -1.03786 25.1483V25.0948L-1.03729 25.0955Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8493 15.3218C28.852 15.3218 24.8545 15.2885 20.8576 15.3376C19.1834 15.3579 17.3964 14.1701 17.1311 12.1568C16.8614 10.1102 18.2327 8.43079 20.045 8.06247C20.2545 8.01968 20.4725 8.00391 20.6865 8.00391C28.8592 8.00898 37.032 8.01743 45.2049 8.02531C45.6036 8.02531 45.6047 8.027 45.6047 8.4353C45.6047 10.5838 45.6047 12.7329 45.6047 14.8814C45.6047 15.2919 45.6036 15.2936 45.179 15.2936C41.0689 15.2936 36.9594 15.2936 32.8493 15.2936V15.3218Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1498_3201)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.96679 25.458L24.8195 25.458L24.8195 7.66165L6.96679 7.66165L6.96679 25.458Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1498_3201"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOhm);
export default __webpack_public_path__ + "static/media/OHM.ebdd2b81c93122a9b8b1a49b601f7508.svg";
export { ForwardRef as ReactComponent };